import { render, staticRenderFns } from "./TestsTabNewQuestion.vue?vue&type=template&id=3e6c3b80&"
import script from "./TestsTabNewQuestion.vue?vue&type=script&lang=js&"
export * from "./TestsTabNewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TestsTabNewQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TestsTabNewQuestion.vue"
export default component.exports